/* @flow */

import React from 'react';
import {connect} from 'react-redux';

import LoadingComponent from 'components/loading';

import AddCompanyViewComponent from './view';

import AddNewCompanyForm from './model';

import CompanyService from 'services/CompanyService';
import {handleApiFormResponse, handleFormChange, handleFormValidation} from 'lib/forms';
import loadConstraints from 'lib/validation/loadConstraints';

import {addCompanyAction} from 'store/actions/authActions';

import NotificationHelper from 'lib/notifications';

type AddCompanyComponentProps = {
  activeCompanyRole: number;
  activeCompanyHasSignedGeneralConditionsAndHasProcuration: boolean;
  addCompanyAction: (number) => void;
}

type AddCompanyComponentState = {
  constraints: any;
  errors: Map<string, ?string>;
  form: AddNewCompanyForm;
  formErrors: string[];
  isLoading: boolean;
  isProcessing: boolean;
}

class AddCompanyComponent extends React.Component<AddCompanyComponentProps, AddCompanyComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      constraints: null,
      errors: null,
      form: null,
      formErrors: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    try {
      const constraints = await loadConstraints('Person', ['mobile', 'functionName', 'company', 'companyType']);

      this.setState({
        constraints,
        errors: new Map(Object.keys(constraints).map(e => [e, undefined])),
        form: new AddNewCompanyForm(this.props.activeCompanyRole),
        isLoading: false
      });
    } catch (e) {
      console.error(e);
      NotificationHelper.createNotification(NotificationHelper.TYPE_ERROR);
    }
  };

  handleChange = (fieldName: string) => (event) => handleFormChange.call(this, fieldName, event.target.value);

  handleCompanyChange = (company: ?Company) => {
    const form = this.state.form;
    form.company = company;

    const errors = this.state.errors;
    errors.delete('company');

    this.setState({errors, form});
  };

  handleCompanyTypeChange = (companyType: number) => {
    const form = this.state.form;
    form.companyType = companyType;
    form.company = null;

    const errors = this.state.errors;
    errors.delete('company');

    this.setState({errors, form});
  };
  handleMobileChange = (value: string) => {
    handleFormChange.call(this, 'mobile', value);
  }

  validateForm = () => handleFormValidation.call(this);

  submitForm = async () => {
    if (!this.validateForm()) return;
    this.setState({formErrors: [], isProcessing: true});

    try {
      const request = this.state.form.toRequest();
      const companyId = await CompanyService.addNewCompany(request);
      this.props.addCompanyAction(companyId);
    } catch (e) {
      handleApiFormResponse.call(this, e);
    }
  };

  render() {
    if (this.state.isLoading) {
      return (<LoadingComponent />);
    }

    return (
      <AddCompanyViewComponent
        errors={this.state.errors}
        form={this.state.form}
        formErrors={this.state.formErrors}
        isProcessing={this.state.isProcessing}
        handleChange={this.handleChange}
        handleCompanyChange={this.handleCompanyChange}
        handleCompanyTypeChange={this.handleCompanyTypeChange}
        handleMobileChange={this.handleMobileChange}
        submitForm={this.submitForm}
        hasSignedGc={this.props.activeCompanyHasSignedGeneralConditionsAndHasProcuration}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyRole: state.auth.user.activeCompany.role,
  activeCompanyHasSignedGeneralConditionsAndHasProcuration: state.auth.user.activeCompany.hasSignedGeneralConditionsAndHasProcuration,
});

export default connect(mapStateToProps, {addCompanyAction})(AddCompanyComponent);
